import styled from 'styled-components';

import Color from '../../styles/color';

export const Container = styled.div<{ small?: boolean }>`
  display: flex;
  margin-bottom: 16px;
  height: ${p => (p.small ? '32px' : 'auto')};
  align-items: ${p => (p.small ? 'center' : 'flex-start')};
`;

export const Clear = styled.div`
  clear: both;
`;

export const Icon = styled.img`
  position: relative;
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;

export const Content = styled.h2`
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: ${Color.neutral};
  width: 80%;

  strong {
    font-weight: bold;
  }
`;
